import React from 'react';

import * as styles from './MembershipActive.styles';

export const MembershipActive = () => {
  return (
    <div css={styles.root}>
      <img
        alt=""
        src="https://images.contentstack.io/v3/assets/blt63f2f7afd19b09c2/blt6af80ed62fff53e2/696a232aead59a0008bc42ac/noths-and-more-active.png?width=100"
      />
      <div>
        <h3>You’re getting 10% off this and everything else</h3>
        <p>Thanks to your NOTHS&More membership!</p>
      </div>
    </div>
  );
};
